var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 81,
    viewBox: "0 0 1440 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1440 49.8506C891.674 164.694 639.36 -87.1002 3.74096e-06 37.9308L6.99382e-06 0.722408L1440 0.722534L1440 49.8506Z",
    fill: "url(#paint0_linear_225_5074)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_225_5074",
    x1: -0.000664353,
    y1: -153.278,
    x2: 6.91573,
    y2: -53.7198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F4FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveEnd);
export default __webpack_public_path__ + "static/media/wave-end.2f287bd57246c11c42a304e94102b1fc.svg";
export { ForwardRef as ReactComponent };